import React, { useState } from "react";
import { Button, Form, Popup } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Allergen } from "ceicons";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";
import { ImageDropzone } from "../../ImageDropzone";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { BlockPicker } from "react-color";

import "./allergenModal.scss";

export default function AllergenModal(props) {
  const { trigger, edit = false, allergen, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState();
  const [fileError, setFileError] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [colorModalActive, setColorModalActive] = useState(true);

  const t = useTranslation();

  const colors = [
    "#12b6f7",
    "#ffc600",
    "#13b966",
    "#ff8200",
    "#e6a37a",
    "#435ba8",
    "#b14273",
    "#c8b8a3",
    "#fff174",
    "#0fdff8",
    "#84df51",
    "#9e6a49",
    "#f28476",
    "#e3be6e",
  ];

  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  function editAllergen() {
    return new Promise((resolve, reject) => {
      const variables = {
        id: formData.id,
        name: formData.name,
        color: formData.color,
      };

      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }
      commitMutation(environment, {
        mutation: AllergenModalUpdateMutation,
        variables,
        uploadables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }
  function createAllergen() {
    return new Promise((resolve, reject) => {
      const variables = { ...formData };

      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }
      commitMutation(environment, {
        mutation: AllergenModalCreateMutation,
        variables,
        uploadables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }
  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? createAllergen : editAllergen;
      const msg = !edit
        ? t("message.created_allergen")
        : t("message.edited_allergen");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;
    if (!formData.name) {
      errors = { ...errors, name: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  const handleChangeComplete = (color) => {
    setFormData({ ...formData, color: color.hex });
  };

  return (
    <BasicModal
      size="tiny"
      className="single-button"
      title={
        <div className="modalTitle">
          <Allergen />
          {edit ? t("modalTitle.editAllergen") : t("modalTitle.createAllergen")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit ? setFormData(allergen) : setFormData({});
          setFile();
        },
      })}
      actions={
        <Button
          type="submit"
          primary
          onClick={() => {
            onSubmit();
          }}
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form className="form-container">
        <Form.Group>
          <ImageDropzone
            circular
            file={file}
            setFile={setFile}
            fileError={fileError}
            setFileError={setFileError}
            imgLoaded={edit && formData.image}
            color={formData.color}
          />
          <Popup
            className="popUpColors"
            on="click"
            pinned
            trigger={
              colorModalActive ? (
                <p onClick={() => setColorModalActive(false)}>
                  {t("form.changeColor")}
                </p>
              ) : (
                <p></p>
              )
            }
            position="bottom center"
            onClose={() => setColorModalActive(true)}
          >
            <BlockPicker
              onChange={handleChangeComplete}
              color={formData.color}
              colors={colors}
            />
          </Popup>
        </Form.Group>

        <Form.Input
          name="name"
          error={formErrors && formErrors["name"]}
          value={formData.name || ""}
          label={t("form.name")}
          placeholder={t("form.name")}
          onChange={handleChange}
          required
        />
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
const AllergenModalCreateMutation = graphql`
  mutation AllergenModalCreateMutation($name: String!, $color: String!) {
    allergenCreate(input: { name: $name, color: $color }) {
      allergen {
        id
        name
        color
        image
      }
    }
  }
`;
const AllergenModalUpdateMutation = graphql`
  mutation AllergenModalUpdateMutation(
    $id: ID!
    $name: String
    $color: String
  ) {
    allergenUpdate(input: { id: $id, name: $name, color: $color }) {
      allergen {
        id
        name
        color
        image
      }
    }
  }
`;
